export enum EGraphFilters {
  POWER = "POWER",
  ENERGY = "ENERGY",
  BATTERY_CHARGED = "BATTERY_CHARGED",
  BATTERY_LEVEL = "BATTERY_LEVEL",
  SYSTEM_OVERALL = "SYSTEM_OVERALL",
}
